import AOS from "aos";
import { useEffect } from "react";

const SectionTwo = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);
  return (
    <>
      {/* <!-- ====================================== About Section Two ===================================== --> */}
      <section className="about-section-two overflow-hidden">
        <div className="container">
          {/* <div
            className="award-circle-main aos-init aos-animate"
            data-aos="zoom-in"
          >
            <div className="award-circle">
              <img src={TrophyImg} alt="trophy" />
            </div>
            <div>
              <h2 className="independent">Independent Of The Year</h2>
              <p className="annual">Annual Awards 2025</p>
            </div>
          </div> */}

          <h3 className="self-taught aos-init aos-animate" data-aos="fade-up">
            <span>We’re Marichi Tech AI</span> — a passionate team of innovators
            and tech enthusiasts
            <span> based in the NEPAL</span>. With roots in diverse digital
            domains, we bring together the best of
            <span> Product Design, Web Development, Mobile Applications</span>,
            and
            <span> Cloud Solutions</span> to create impactful digital
            experiences.
          </h3>

          <p className="odio aos-init aos-animate" data-aos="fade-up">
            Backed by years of industry expertise, our award-winning
            professionals are committed to delivering scalable, user-centric,
            and future-ready solutions for businesses across the globe. At
            Marichi Tech AI, we blend creativity with cutting-edge technology to
            build powerful digital products that elevate brands, streamline
            operations, and drive growth. From ideation to execution, we are
            your partners in digital transformation.
          </p>
        </div>
      </section>
      {/* <!-- ====================================== About Section Two End ===================================== --> */}
    </>
  );
};
export default SectionTwo;
